import {
  IDV360TicketsInsertionOrder,
  IDV360TicketsInsertionOrdersFormData,
} from '@/Interfaces/DV360Tickets/InsertionOrder.interface';
import { getAdvertiserControlOption } from '@/helpers/advertisers';

export const insertionOrderApiDataToFormStructure = (
  insertionOrder: IDV360TicketsInsertionOrder,
): IDV360TicketsInsertionOrdersFormData => ({
  name: insertionOrder.name,
  advertiser: getAdvertiserControlOption(insertionOrder.advertiser),
  altId: insertionOrder.alt_id ?? '',
});
